<template>
  <div>
    <div class="float-ai-wrapper">
      <div class="float-ai-tooltip">
        Holle，你好，我是会学习能对话的虚拟助教，<br />
        快来与我对话吧!
      </div>
      <div class="float-ai-btn" @click="openDrawer">
        <img :src="require('@/assets/aistudy.png')" alt="AI助手" />
      </div>
    </div>

    <div
      class="ai-drawer-mask"
      v-if="visible && !isFullscreen"
      @click="closeDrawer"
    ></div>

    <div
      class="ai-drawer"
      :class="{
        'ai-drawer-fullscreen': isFullscreen,
        'ai-drawer-hidden': !visible
      }"
      v-show="visible"
    >
      <div class="ai-drawer-header">
        <img
          v-if="!isFullscreen"
          :src="require('@/assets/aiassistant/fangda.png')"
          class="btn-com"
          @click.stop="toggleFullscreen"
        />
        <img
          v-if="isFullscreen"
          :src="require('@/assets/aiassistant/suoxiao.png')"
          class="btn-com"
          @click.stop="toggleFullscreen"
        />
        <img
          :src="require('@/assets/aiassistant/guanbi.png')"
          class="btn-com"
          @click.stop="closeDrawer"
        />
      </div>

      <div class="ai-drawer-body">
        <div class="chat-top">
          <div class="consult-online">在线咨询</div>
          <div class="ppl-ask">博纳众问，笃行答疑_</div>
        </div>

        <div class="chat-messages" ref="chatMessagesRef">
          <!-- 初始欢迎和功能推荐 -->
          <div class="start-chat">
            <div class="guide-assistant">
              您好，我是您的智能导学助手！
            </div>
            <div class="recommend">为您推荐以下内容</div>
            <div class="chat-options-info" style="margin-top: 10px;" v-for="(item, index) in dataList" :key="index" @click="handleClickOption(item)">
              <div class="chat-options">
                <img :src="item.image" class="chat-img-options"/>
                {{item.name}}
              </div>
              <div class="options-detail">{{item.recommend}}</div>
            </div>
          </div>

          <!-- 聊天消息历史 -->
          <div class="message-history">
            <div
              v-for="message in messages"
              :key="message.id"
              :class="[
                'message-item',
                message.sender === 'user' ? 'user-message' : 'assistant-message'
              ]"
            >
              <div class="message-avatar" v-if="message.sender === 'assistant'">
                <div class="ai-avatar-placeholder">AI</div>
              </div>

              <div class="message-content">
                <div class="message-text">{{ message.content }}</div>

                <!-- 来源 / 置信度 -->
                <div
                  class="message-meta"
                  v-if="message.sender === 'assistant' && (message.source || message.confidence !== null)"
                >
                  <span
                    class="source-tag"
                    :class="message.source"
                    v-if="message.source"
                  >
                    {{ getSourceText(message.source) }}
                  </span>
                  <span
                    class="confidence"
                    v-if="message.confidence !== null && message.confidence !== undefined"
                  >
                    置信度: {{ (Number(message.confidence) * 100).toFixed(0) }}%
                  </span>
                </div>

                <!-- 命中来源 -->
                <div
                  class="matched-segments"
                  v-if="
                    message.sender === 'assistant' &&
                    message.metadata &&
                    message.metadata.references &&
                    message.metadata.references.length
                  "
                >
                  <div class="matched-title">数据来源</div>
                  <div
                    v-for="(ref, idx) in message.metadata.references"
                    :key="idx"
                    class="matched-item"
                  >
                    {{ idx + 1 }}.
                    {{ ref.courseTaskStageName || ref.taskStageId }}
                  </div>
                </div>
              </div>

              <div class="message-avatar user-avatar" v-if="message.sender === 'user'">
                <div class="user-avatar-placeholder">我</div>
              </div>
            </div>

            <!-- 加载中 -->
            <div class="loading-indicator" v-if="isLoading">
              <div class="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="loading-text">AI助手正在思考...</div>
            </div>
          </div>
        </div>

        <div class="chat-bottom">
          <div class="bottom-fun-wrap">
            <div class="bottom-fun" @click="askPresetQuestion('如何报名')">
              <img :src="require('@/assets/aiassistant/baoming.png')" class="chat-img-com" />
              如何报名
            </div>
<!--            <div class="bottom-fun" @click="askPresetQuestion('如何开发票')">-->
<!--              <img :src="require('@/assets/aiassistant/kaifapiao.png')" class="chat-img-com" />-->
<!--              如何开发票-->
<!--            </div>-->
            <div class="bottom-fun" @click="askPresetQuestion('如何打印证书')">
              <img :src="require('@/assets/aiassistant/zhengshu.png')" class="chat-img-com" />
              证书打印
            </div>
            <div class="bottom-fun" @click="askPresetQuestion('忘记密码怎么办')">
              <img :src="require('@/assets/wangjimima.png')" class="chat-img-com" />
              忘记密码
            </div>
          </div>

          <div class="bottom-fun-wrap">
            <div class="input-clear" @click="clearInput">
              <img :src="require('@/assets/aiassistant/qingkong.png')" class="clear-img" />
            </div>

            <div class="input-container">
              <input
                class="input-inner"
                v-model="inputVal"
                placeholder="有问题尽管问我~..."
                @keyup.enter="sendMsg"
              />
              <button class="send-btn-wrap" @click="sendMsg">
                <img :src="require('@/assets/aiassistant/fasong.png')" class="send-btn" />
                发送
              </button>
            </div>
          </div>

          <div class="warning-font">内容由AI生成，仅供参考</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aiqaApi from '@/apis/student/aiqa'
import getLocal from '@/common/cookie'

export default {
  name: 'AiAssistant',
  props: {
    courseId: {
      type: String,
      default: ''
    },
    taskStageId: {
      type: String,
      default: ''
    },
    studentId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      isFullscreen: false,
      inputVal: '',
      messages: [],
      isLoading: false,
      dataList: [{
        name: '学习效果评估',
        image: require('@/assets/aiassistant/pinggu.png'),
        recommend: '一键评估学习状况，智能定位薄弱环节',
        value: 1
      },
      {
        name: '学习诊断报告',
        image: require('@/assets/aiassistant/baogao.png'),
        recommend: '以数据为依据，为成长指明方向',
        value: 2
      },
      {
        name: '学习资源推荐',
        image: require('@/assets/aiassistant/tuijian.png'),
        recommend: '精准匹配学习需求，智能推送优质资源',
        value: 3
      }]
    }
  },
  mounted () {
    this.addMessage(
      'assistant',
      '您好，我是您的智能导学助手！我可以帮您解答课程相关问题，也可以回答系统操作问题，如：如何报名、如何开发票、如何打印证书等。'
    )
  },
  methods: {
    handleClickOption (item) {
      this.closeDrawer()
      this.$router.push({
        path: '/studycenter',
        query: {
          menu: 8,
          source: 'aiassistant',
          tarValue: item.value
        }
      })
    },

    openDrawer () {
      this.visible = true
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },

    closeDrawer () {
      this.visible = false
      this.isFullscreen = false
    },

    toggleFullscreen () {
      this.isFullscreen = !this.isFullscreen
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },

    addMessage (sender, content, extra = {}) {
      this.messages.push({
        id: Date.now() + Math.random(),
        sender,
        content,
        timestamp: new Date(),
        source: extra.source || '',
        confidence: extra.confidence !== undefined ? extra.confidence : null,
        metadata: extra.metadata || {}
      })

      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },

    scrollToBottom () {
      const chatMessages = this.$refs.chatMessagesRef
      if (chatMessages) {
        chatMessages.scrollTop = chatMessages.scrollHeight
      }
    },

    /**
     * 构建临时上下文
     * - 不入库
     * - 刷新丢失
     * - 每次取最近 6 条消息（约 3 轮）
     */
    buildContext () {
      const recentMessages = (this.messages || []).slice(-6)

      if (!recentMessages.length) {
        return ''
      }

      return recentMessages
        .map(msg => {
          const role = msg.sender === 'user' ? '用户' : '助手'
          const content = (msg.content || '').slice(0, 150)
          return `${role}：${content}`
        })
        .join('\n')
    },

    checkLogin () {
      const token = getLocal.getCookie('token')
      if (!token) {
        this.$message.warning('请先登录后再使用AI助手')
        this.$login.show()
        return false
      }
      return true
    },

    async sendMsg () {
      const question = (this.inputVal || '').trim()
      if (!question || this.isLoading) {
        return
      }

      if (!this.checkLogin()) {
        return
      }

      const context = this.buildContext()

      this.addMessage('user', question)
      this.inputVal = ''
      this.isLoading = true

      try {
        const res = await aiqaApi.enhancedChat({
          question,
          context,
          courseId: this.courseId || '',
          taskStageId: this.taskStageId || '',
          studentId: this.studentId || ''
        })

        console.log('AI问答原始返回:', res)

        const payload = res && res.data && res.data.answer
          ? res.data
          : (res && res.data && res.data.data
            ? res.data.data
            : (res && res.answer ? res : {}))

        this.addMessage(
          'assistant',
          payload.answer || '暂时没有获取到回答',
          {
            source: payload.source || '',
            confidence: payload.confidence,
            metadata: payload.metadata || {}
          }
        )
      } catch (error) {
        console.error('调用AI问答接口失败:', error)
        this.addMessage(
          'assistant',
          'AI问答调用失败，请稍后重试。',
          {
            source: 'fallback',
            confidence: 0
          }
        )
      } finally {
        this.isLoading = false
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },

    askPresetQuestion (question) {
      this.inputVal = question
      this.sendMsg()
    },

    clearInput () {
      this.inputVal = ''
      this.messages = []
    },

    getSourceText (source) {
      const sourceMap = {
        preset: '预设问答',
        vector: '课程内容',
        llm: 'AI生成',
        fallback: '兜底回答'
      }
      return sourceMap[source] || '未知来源'
    }
  }
}
</script>

<style scoped>
.float-ai-wrapper {
  position: fixed;
  right: 24px;
  bottom: 72px;
  display: flex;
  align-items: center;
  z-index: 2000;
}

.float-ai-tooltip {
  display: none;
  position: absolute;
  right: calc(100% + 10px);
  white-space: nowrap;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  background: linear-gradient(90deg, #C9EFFF 0%, #E5DFFF 100%);
  border: 1px solid #64D2FF;
  border-radius: 14px 14px 0px 14px;
}

.float-ai-wrapper:hover .float-ai-tooltip {
  display: block;
}

.float-ai-btn {
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}

.float-ai-btn:hover {
  box-shadow: 0 6px 24px rgba(42, 120, 255, 0.3);
  transform: scale(1.08);
}

.float-ai-btn img {
  width: 43px;
  height: 43px;
  object-fit: contain;
}

.ai-drawer-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2001;
}

.ai-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 30%;
  height: 100%;
  background: linear-gradient(17deg, #F3E7E9 0%, #F5F9FF 51.65%, #E3EEFF 100%);
  z-index: 2002;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.12);
  transition: width 0.3s ease, transform 0.3s ease;
  transform: translateX(0);
}

.ai-drawer[style*="display: none"],
.ai-drawer.v-show-hidden {
  transform: translateX(100%);
}

.ai-drawer-fullscreen {
  width: 100% !important;
}

.ai-drawer-fullscreen .ai-drawer-header,
.ai-drawer-fullscreen .ai-drawer-body {
  width: 50%;
  margin: 0 auto;
  padding: 0 20px;
}

.ai-drawer-fullscreen .ai-drawer-header {
  margin-top: 20px;
}

.ai-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 30px;
  flex-shrink: 0;
}

.ai-drawer-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 30px;
}

.chat-top {
  flex-shrink: 0;
  padding-top: 4px;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 13px;
  margin: 12px 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.chat-messages::-webkit-scrollbar {
  display: none;
}

.chat-bottom {
  flex-shrink: 0;
  padding-bottom: 0px;
}

.btn-com {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.chat-img-com {
  width: 15px;
  height: 15px;
}

.recommend {
  font-weight: 400;
  font-size: 13px;
  margin: 16px 0px 14px;
  color: #666666;
}

.clear-img {
  width: 18px;
  height: 18px;
}

.ppl-ask {
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 4px;
  text-align: center;
  color: #5B5B5B;
}

.consult-online {
  font-weight: 700;
  text-align: center;
  font-size: 20px;
  color: #333333;
}

.bottom-fun-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  gap: 14px;
}

.bottom-fun {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s;
}

.bottom-fun:hover {
  background-color: rgba(74, 144, 226, 0.1);
}

.input-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #fff;
  gap: 14px;
  border-radius: 50%;
  cursor: pointer;
}

.input-container {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 4px 4px 4px 10px;
  width: 80%;
  border: 1px solid #e0e0e0;
  overflow: hidden;
}

.ai-drawer-fullscreen .input-container {
  width: calc(100% - 54px);
}

.guide-assistant {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.input-inner {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: #333;
  background: transparent;
}

.send-btn-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 75px;
  height: 27px;
  font-weight: 400;
  flex-shrink: 0;
  border: none;
  border-radius: 6px;
  background: #4A90E2;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  justify-content: center;
}

.send-btn {
  width: 13px;
  height: 13px;
}

.warning-font {
  font-weight: 500;
  font-size: 12px;
  color: #999999;
  text-align: center;
  margin: 5px 0px 8px;
}

.chat-img-options {
  width: 13px;
  height: 14px;
}

.chat-options {
  font-weight: 700;
  font-size: 14px;
  color: #333;
}

.options-detail {
  font-weight: 400;
  font-size: 11px;
  margin-top: 7px;
  color: #666666;
}

.chat-options-info {
  padding: 14px 10px;
  cursor: pointer;
  margin-top: 12px;
  background-color: #F7F6F9;
  border-radius: 10px;
}

.message-history {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
}

.message-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.user-message {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.user-avatar {
  background: #4A90E2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}

.message-content {
  max-width: 70%;
}

.user-message .message-content {
  text-align: right;
}

.message-text {
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
}

.assistant-message .message-text {
  background: white;
  border: 1px solid #E5E5E5;
  color: #333;
  border-top-left-radius: 4px;
}

.user-message .message-text {
  background: #4A90E2;
  color: white;
  border-top-right-radius: 4px;
}

.message-meta {
  margin-top: 6px;
  font-size: 11px;
  color: #999;
  display: flex;
  gap: 8px;
  align-items: center;
}

.source-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
}

.source-tag.preset {
  background: #E8F4FF;
  color: #1A73E8;
}

.source-tag.vector {
  background: #E6F4EA;
  color: #137333;
}

.source-tag.llm {
  background: #FEF7E0;
  color: #E37400;
}

.source-tag.fallback {
  background: #F3E5F5;
  color: #8E24AA;
}

.confidence {
  font-size: 10px;
}

.matched-segments {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.matched-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 6px;
}

.matched-item {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 4px;
  word-break: break-word;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px;
}

.loading-dots {
  display: flex;
  gap: 4px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4A90E2;
  animation: dot-flash 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes dot-flash {
  0%, 80%, 100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}

.loading-text {
  font-size: 12px;
  color: #666;
}

.start-chat {
  background-color: #fff;
  border-radius: 6px;
  padding: 18px 16px;
  width: 60%;
}

.ai-avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #4A90E2 0%, #64D2FF 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.user-avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #4A90E2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}
</style>
